
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoInvoiceReceiveDtDialog extends Serenity.Extensions.GridEditorDialog<PoInvoiceReceiveDtRow> {
        protected getFormKey() { return PoInvoiceReceiveDtForm.formKey; }
        // protected getIdProperty() { return PoInvoiceReceiveDtRow.idProperty; }
        protected getLocalTextPrefix() { return PoInvoiceReceiveDtRow.localTextPrefix; }
        protected getNameProperty() { return PoInvoiceReceiveDtRow.nameProperty; }
        // protected getService() { return PoInvoiceReceiveDtService.baseUrl; }
        // protected getDeletePermission() { return PoInvoiceReceiveDtRow.deletePermission; }
        // protected getInsertPermission() { return PoInvoiceReceiveDtRow.insertPermission; }
        // protected getUpdatePermission() { return PoInvoiceReceiveDtRow.updatePermission; }

        protected form = new PoInvoiceReceiveDtForm(this.idPrefix);
        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;

        constructor() {
            super();
            this.form = new PoInvoiceReceiveDtForm(this.idPrefix);

        
            this.form.DiscText.changeSelect2(e => {
                var discStr = this.form.DiscText.value;
                if (discStr) {
                    //20%,5%,200
                    let a = discStr.split(",")
                    console.log(a)
                    var totalAmt = this.form.BeforeDiscAmt.value;
                    var discamt = 0
                    //var net = 0

                    for (var po of a) {

                        if (po.includes("%")) {
                            let a = po.replace("%", "");
                            let b = Number(a);
                            console.log(b)
                            let amt = totalAmt * b / 100
                            discamt = discamt + amt;
                            totalAmt = totalAmt - amt;
                        } else {
                            let x = Number(po)
                            discamt = discamt + x
                            totalAmt = totalAmt - x;
                        }

                    }

                    console.log("Lasttotal:" + totalAmt)
                    console.log("DiscAmt:" + discamt)

                    this.form.DiscAmt.value = discamt
                    this.form.ItemAmt.value = totalAmt
                    this.form.ItemNetAmt.value = totalAmt - (this.form.AlocalteDiscAmt.value || 0)

                    // const disAmt =  (totalAmt * discStr) / 100;
                    // this.form.DiscAmt.value = disAmt;
                    //this.form.NetAmt.value = totalAmt - disAmt;
                    this.CalVat();

                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.BeforeDiscAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });

            

            this.form.Qty.changeSelect2(e => {
                var skucode = Q.toId(this.form.Qty.value);
                if (skucode != null) {

                    var PrRef :string = this.form.PiRefDocNo.value
                    
                    if(!Q.isEmptyOrNull(PrRef)){
                        var line = this.form.PiLineId.value
                       let pr =  Q.first(Purchase.PoPurOrderDtRow.getLookup().items, x => x.Id == line && x.SysDocNo==PrRef);
                        let lessqty = pr.StkQty-pr.QtyUse
                        if(lessqty < (this.form.Qty.value*this.form.PurUnitRatio.value) ){
                            Q.warning("จำนวนคงเหลือ ไม่เพียงพอ")
                            this.form.Qty.value = lessqty/this.form.PurUnitRatio.value
                        }

                    }

                    this.Calamt();
                }
            });

            this.form.PurUnitPrice.changeSelect2(e => {
                var skucode = Q.toId(this.form.PurUnitPrice.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

            this.form.BeforeDiscAmt.changeSelect2(e => {
                var skucode = Q.toId(this.form.BeforeDiscAmt.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });





        }
        private get StkUnit() {
            return this.form.UnitChange.value != "0";
        }
        private get PurUnit() {
            return this.form.UnitChange.value != "1";
        }

        private checkOverQty() {
            var PrRef: string = this.form.PiRefDocNo.value
            var line = this.form.PiLineId.value
            let pr = Q.first(Purchase.PoPurInvoiceDtRow.getLookup().items, x => x.Id == line && x.SysDocNo == PrRef);
            let lessqty = pr.StkQty - pr.QtyUse
            if (lessqty < (this.form.Qty.value * this.form.PurUnitRatio.value)) {
                Q.warning("จำนวนคงเหลือ ไม่เพียงพอ")
                this.form.Qty.value = lessqty / this.form.PurUnitRatio.value
            }
        }

        // protected validateBeforeSave(): boolean {
        //     super.validateBeforeSave();
        //     this.checkOverQty()
        //     return this.validateBeforeSave();
        // }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }

        // private saveAndNew() {
        //     let e = this.entity; let f = this.form;
        //     // if (e.SkuCode == null) {
        //     //     e.SkuCode = f.SkuCode.value;

        //     // }
        //     this.save((response) => {
        //         let ent: PoInvoiceReceiveDtRow = {
        //             SysDocNo: e.SysDocNo,
        //             SupplierId: f.SupplierId.value,
        //             WhsId: f.WhsId.value
        //             ,ShopId: f.ShopId.value
        //         };
        //         this.loadEntity(ent);
        //     });
        // }
        protected beforeLoadEntity() {
            let self = this;



            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }

        private Calamt() {



            this.form.BeforeDiscAmt.value = (this.form.PurUnitPrice.value) * (this.form.Qty.value);

            this.form.ItemAmt.value = (this.form.BeforeDiscAmt.value - this.form.DiscAmt.value) 
            
            this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0);
            // console.log(this.form.DiscAmt.value + "dis");
            this.CalVat();


        }


        private CalVat() {


            const Totalafterdis = this.form.ItemNetAmt.value

            var vatRate = this.form.VatRate.value

            var salev = this.form.SalesVatTypes.value

            console.log("vattype:"+salev)
            if(salev == "E"){
            this.form.ItemVatAmt.value = (Totalafterdis* (vatRate/100));
            this.form.ItemExVatAmt.value = Totalafterdis
            this.form.ItemNetCostValue.value = Totalafterdis+this.form.ItemVatAmt.value+this.form.ItemExciseTaxAmt.value
            }    //vat นอก       
            else {
            this.form.ItemVatAmt.value = (Totalafterdis * vatRate) / (vatRate + 100);
            this.form.ItemExVatAmt.value = Totalafterdis - this.form.ItemVatAmt.value
            this.form.ItemNetCostValue.value = Totalafterdis +this.form.ItemExciseTaxAmt.value
        }

        }

    }
}